/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Helmet } from 'react-helmet';
import MPHFooterPrimary from "src/components/actionPerformers/MPHFooterPrimary/MPHFooterPrimary";
import MPHFooterSecondary from "src/components/actionPerformers/MPHFooterSecondary/MPHFooterSecondary";
import MPHHeaderMain from "src/components/actionPerformers/MPHHeaderMain/MPHHeaderMain";
import "./MyBenefits.scss";
import MPHMyBenefitsComponent from "src/components/actionPerformers/MPHMyBenefitsComponent/MPHMyBenefitsComponent";
import MPHPrimaryCard from "src/components/DataHolders/MPHPrimaryCard/MPHPrimaryCard";
import laZebraImage from "src/assets/images/image.webp";

const MyBenefits = () => {

  return (
    <>
      <Helmet>
        <title>Stay Rewarded Member Benefits - My Place Hotels</title>
        <meta name="description" content="Explore exclusive benefits of Stay Rewarded. Enjoy special rates, earn points, and access personalized offers at My Place Hotels." />
      </Helmet>
      <MPHHeaderMain active="/benefits" />
      <div className="margin-top">
        <div className="benefits-container">
          <MPHMyBenefitsComponent/>         
          <div className="benefits-promo-section">
            <h2 className="promo-section-title">Exclusive La Zebra Tulum Member Rates</h2>
            <MPHPrimaryCard
              url={laZebraImage}
              header="Save on Luxury"
              height="small"
              helperText="As a Stay Rewarded Member, you are eligible for exclusive member rates at La Zebra Tulum, one of Tulum's most sought-after luxury beachfront resorts. Save up to 50% now with promo code MYPLACETULUM!"
              buttonType="primary-button"
              buttonText="Book Now!"
              onbuttonClick={() => window.open("https://www.lazebratulum.com/", "_blank", "noopener,noreferrer")}
            />
          </div>
        </div>
        <MPHFooterPrimary />
        <MPHFooterSecondary />
      </div>
    </>
  );
};

export default MyBenefits;
